import CodeIcon from '@material-ui/icons/Code';
import LaunchIcon from '@material-ui/icons/Launch';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { publications } from '../../portfolio';
import ScrollReveal from '../ScrollReveal/ScrollReveal';
import './Publications.css';

const ICONS = {
  code: CodeIcon,
  external: LaunchIcon,
  paper: MenuBookIcon,
  pdf: PictureAsPdfIcon,
};

const Publications = () => {
  if (!publications.length) return null;

  return (
    <section id='publications' className='section publications'>
      <ScrollReveal>
        <h2 className='section__title'>Publications & Presentations</h2>
      </ScrollReveal>

      <div className='publications__list'>
        {publications.map((publication, index) => (
          <ScrollReveal key={publication.title} delay={index * 100}>
            <article className='publication glass-card'>
              <div className='publication__topline'>
                <span className='publication__type'>{publication.type}</span>
                {publication.doi && (
                  <a
                    href={`https://doi.org/${publication.doi}`}
                    target='_blank'
                    rel='noreferrer'
                    className='publication__doi link'
                  >
                    DOI: {publication.doi}
                  </a>
                )}
              </div>

              <h3 className='publication__title'>{publication.title}</h3>
              <p className='publication__authors'>{publication.authors}</p>
              <p className='publication__venue'>{publication.venue}</p>
              <p className='publication__summary'>{publication.summary}</p>

              {publication.highlights?.length > 0 && (
                <ul className='publication__highlights'>
                  {publication.highlights.map((highlight) => (
                    <li key={highlight}>{highlight}</li>
                  ))}
                </ul>
              )}

              {publication.links?.length > 0 && (
                <div className='publication__links'>
                  {publication.links.map(({ label, url, kind }) => {
                    const Icon = ICONS[kind] || LaunchIcon;

                    return (
                      <a
                        key={`${label}-${url}`}
                        href={url}
                        target='_blank'
                        rel='noreferrer'
                        className='publication__link'
                      >
                        <Icon fontSize='small' />
                        {label}
                      </a>
                    );
                  })}
                </div>
              )}
            </article>
          </ScrollReveal>
        ))}
      </div>
    </section>
  );
};

export default Publications;
